import { cn } from '@repo/utils';
import { Money } from './Money';
import { DEFAULT_CURRENCY, DEFAULT_LOCALE } from '../../lib/locale';

interface AmountDisplayProps {
  paise: number;
  currency?: string;
  locale?: string;
  emphasis?: 'hero' | 'inline' | 'table';
  negative?: boolean;
  className?: string;
}

export function AmountDisplay({
  paise,
  currency = DEFAULT_CURRENCY,
  locale = DEFAULT_LOCALE,
  emphasis,
  negative,
  className,
}: AmountDisplayProps) {
  return (
    <Money
      paise={paise}
      currency={currency}
      locale={locale}
      emphasis={emphasis}
      negative={negative}
      className={className}
    />
  );
}
